import axios from 'axios';

/**
 * API base URL:
 * - Production build (`npm run build`): **always** same-origin `/api` — never `localhost:5020`
 *   (fixes ERR_CONNECTION_REFUSED when the UI is opened as https://your-domain but the
 *   browser would otherwise call your PC’s localhost, or when testing from localhost
 *   against a remote API).
 * - Development (`npm start`): on localhost, use REACT_APP_API_URL or http://localhost:5020
 */
function resolveApiBase() {
  if (typeof window === 'undefined') {
    return (process.env.REACT_APP_API_URL || '').trim().replace(/\/$/, '');
  }

  /* Inlined as literal "production" in optimized builds */
  if (process.env.NODE_ENV === 'production') {
    return '';
  }

  const host = window.location.hostname;
  const isLocal = host === 'localhost' || host === '127.0.0.1';
  if (!isLocal) {
    return '';
  }

  const fromEnv = (process.env.REACT_APP_API_URL || '').trim().replace(/\/$/, '');
  return fromEnv || 'http://localhost:5020';
}

const base = resolveApiBase();
const baseURL = base ? `${base}/api` : '/api';

export const api = axios.create({
  baseURL,
  headers: { 'Content-Type': 'application/json' },
});

export function setAuthToken(token) {
  if (token) {
    api.defaults.headers.common.Authorization = `Bearer ${token}`;
    try {
      sessionStorage.setItem('adtech_token', token);
    } catch {
      /* ignore */
    }
  } else {
    delete api.defaults.headers.common.Authorization;
    try {
      sessionStorage.removeItem('adtech_token');
    } catch {
      /* ignore */
    }
  }
}

try {
  const t = sessionStorage.getItem('adtech_token');
  if (t) api.defaults.headers.common.Authorization = `Bearer ${t}`;
} catch {
  /* ignore */
}
